import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/dist/shared/lib/lazy-dynamic/dynamic-bailout-to-csr.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/dist/shared/lib/lazy-dynamic/preload-chunks.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/app/homepage/components/CustomerExperience.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/app/homepage/components/EVSpecialization.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/app/homepage/components/HeroSection.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/app/homepage/components/HomeCTA.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/app/homepage/components/MarqueeBanner.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/app/homepage/components/ServicesOverview.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/app/homepage/components/StatsBanner.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/app/homepage/components/TrustSignals.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/components/Footer.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/components/Header.tsx");
